import Price from '~/utils/Price';

import { ComparativePriceProduct } from './ComparativePriceProduct';

export class ComparativePrice {
	public constructor(public readonly price: Price, public readonly fromProducts: ComparativePriceProduct[]) {}
}
